var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2766_9473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V27.4286H0",
    fill: "#EE1C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33244 2.1001L7.21336 7.7985L2.28906 4.27669H8.37583L3.45153 7.7985",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.084 1.13393L10.9058 3.12344L9.86197 1.41084L11.7291 2.19238L9.7519 2.64042",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5657 3.46872L12.6173 5.23428L12.3304 3.25713L13.7431 4.69066L11.7442 4.34831",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.803 6.98982L12.2053 8.22093L12.7627 6.30055L13.4585 8.17667L11.7753 7.06142",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.043 8.46756L10.9488 10.4626L9.83371 8.79411L11.7322 9.49876L9.77552 10.0271",
    fill: "#FFFF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2766_9473"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -0.00244141,
    width: 32,
    height: 24.0047,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCn);
export default __webpack_public_path__ + "static/media/cn.f4ae83edf16fa4a8444543f400668c68.svg";
export { ForwardRef as ReactComponent };